import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// env
import { environment } from './../../../../environments/environment';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

/* jquery */
declare var $: any;

@Component({
  selector: 'app-disclosures',
  templateUrl: './disclosures.component.html',
  styles: [
  ]
})
export class DisclosuresComponent implements OnInit {
  
  dataTitle;
  dataSection = [];
  dataProspectus;
  dataAnggaranDasar;
  apiAsset = environment.API_ASSETS;
  yearAnnoun;
  dataYearAnnoun = [];
  dataAnnoun;
  dataPerAnnoun;
  dataBond;
  isLang;
  isActivePdf;

  constructor(private apiService: ApiService, 
              private globalService: GlobalService,
              private router: Router) {
    this.globalService.isLoading.next(true); 
  }

  ngOnInit(): void {
    // MultiLanguage
   this.isLang =  this.apiService.isLang();

    // Content
    this.apiService.getDataApi('getMenuSection/disclosure').subscribe(response => {
      if(response.success) {
        this.dataTitle = response.data;
        this.dataSection = response.data.section;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.globalService.isLoading.next(false);
      } else {
        this.router.navigate(['/not-found']);
      }
    });
    
    // docs
    this.apiService.getDataApi('getDocument/2').subscribe(response => {
      this.dataProspectus = response.data.reverse();
    });

    // docs
    this.apiService.getDataApi('getDocument/19').subscribe(response => {
      this.dataAnggaranDasar = response.data.reverse();
    });

    this.apiService.getDataApi('getDocumentYear?category=11').subscribe(response => {
      this.dataAnnoun = response.data;
      this.isActivePdf = response.isActive;
      response.data.forEach((i,x) => {
        if(i.year){
          this.dataYearAnnoun.push(i.year);
        }
        this.yearAnnoun = this.dataYearAnnoun[0];
        if(this.yearAnnoun == i.year){
          this.dataPerAnnoun = i.content;
        }
      });
    });
    this.apiService.getDataApi('getDocumentYear?category=12').subscribe(response => {
      this.dataBond = response.data[0].content[0];
    });
  }

  valueChangedAnnoun(event: string) {
    this.dataAnnoun.forEach((i,x) => {
      if(i.year == event){
        this.dataPerAnnoun = i.content;
      }
    });
  }

  ngOnDestroy(){
    /* clear select2 */
    const selectOptionsContainer = $('.select2-container');
    selectOptionsContainer.removeClass('select2-container--open');
  }

}
